export const API = "https://api.bctong.co.kr/api";
// export const API = "http://localhost:1337/api";
export const APP_NAME = "배차통";

export const COMPANY = {
  NAME: "바른물류연구소 주식회사",
  BUSINESS_NUMBER: "556-81-03004",
  CEO: "권오성",
  TEL: "02-1234-1234",
  EMAIL: "kimtj@me.com",
  ADDRESS: "수원시 영통구 인계로 286 3층 일부",
};
